import React, { useEffect } from 'react';
import { plusWhite } from "../../../assets/svgs";
import FlatButtons from "../../../components/FlatButton/FlatButton";
import { StoreDetailsCard } from '../../../marketPlace/components/storeDetailsCard';
import Typography from "../../../components/Typography/Typography";
import styles from "./style.module.css";
import { useNavigate } from "react-router-dom";
import { useGetStoreByOwnerQuery } from '../../../redux/services/storesApi';

export const SellerStore: React.FC = () => {
    const navigate = useNavigate();
    const defaultPlaceholderImage = 'https://placehold.co/210x121/';

    const {
        data: storesData,
        isLoading: isStoresLoading,
        error: storesError,
        refetch: refetchStores,
    } = useGetStoreByOwnerQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });

    useEffect(() => {
        refetchStores();
    }, [refetchStores]);

    const formatJoinDate = (dateString: string) => {
        try {
            const date = new Date(dateString);
            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();
            return `Joined ${month} ${year}`;
        } catch (error) {
            return 'Joined Recently';
        }
    };

    const calculateStoreStats = (store: any) => {
        return {
            itemCount: 0,
            rating: '0.0',
            price: 0,
        };
    };

    if (isStoresLoading) {
        return (
            <div className={styles.container}>
                <div style={{ textAlign: 'center', padding: '40px 20px', width: '100%' }}>
                    <Typography variant="heading5" fontFamily="satoshi">
                        Loading stores...
                    </Typography>
                </div>
            </div>
        );
    }

    if (storesError) {
        const errorMessage = 'error' in storesError
            ? storesError.error
            : 'status' in storesError
                ? `Error: ${storesError.status}`
                : 'Failed to load stores';

        return (
            <div className={styles.container}>
                <div style={{ textAlign: 'center', padding: '40px 20px', width: '100%' }}>
                    <Typography
                        variant="heading5"
                        fontFamily="satoshi"
                        className={styles.errorTitle}
                    >
                        Error Loading Stores
                    </Typography>
                    <Typography variant="bodyRegular" fontFamily="satoshi">
                        {errorMessage}
                    </Typography>
                    <button
                        onClick={() => refetchStores()}
                        style={{
                            marginTop: '20px',
                            padding: '10px 20px',
                            background: '#1D1D1C',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontFamily: 'Satoshi',
                        }}
                    >
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            {storesData && storesData.length > 0 ? (
                <>
                    {storesData.map((store) => {
                        const stats = calculateStoreStats(store);
                        return (
                            <StoreDetailsCard
                                key={store._id}
                                storePreview={store.logo_url || defaultPlaceholderImage}
                                storeName={store.name}
                                storeRating={stats.rating}
                                storeCreationDate={formatJoinDate(store.created_at)}
                                storeItemCount={stats.itemCount}
                                storeLocation={store.location}
                                storePrice={stats.price}
                                storeId={store._id}
                                onClick={() => {
                                    navigate(`/store/${store.slug}`);
                                }}
                            />
                        );
                    })}

                    <div className={styles.addStoreContainer}>
                        <FlatButtons
                            onClick={() => navigate('/create-store')}
                            className={styles.storeBtn}
                        >
                            <img src={plusWhite} alt=" addition sign" />
                            <Typography>
                                Add Store
                            </Typography>
                        </FlatButtons>
                    </div>
                </>
            ) : (
                <div style={{ textAlign: 'center', padding: '40px 20px', width: '100%' }}>
                    <Typography
                        variant="bodyRegular"
                        fontFamily="satoshi"
                    >
                        You haven't created any stores yet.
                    </Typography>
                    <button
                        onClick={() => navigate('/create-store')}
                        style={{
                            marginTop: '16px',
                            padding: '12px 24px',
                            background: '#1D1D1C',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontFamily: 'Satoshi',
                            fontSize: '14px',
                            fontWeight: '500',
                        }}
                    >
                        Create Your First Store
                    </button>
                </div>
            )}
        </div>
    );
};